import { Route } from "react-router-dom";
import AbpnSpinner from "../Shared/Components/AbpnSpinner";
import { AuthConsumer } from "./AuthProvider";

export const AuthorizeRoute = ({ component, ...rest }: any) => {

    const renderFn = (Component :any) => (props: any) => (
        <AuthConsumer>
            {({ isAuthenticated, signinRedirect }) => {
                if (!!Component && isAuthenticated()) {
                    return <Component {...props} />;
                } else {
                    signinRedirect(null, window.location.pathname);
                    return <AbpnSpinner/>;
                }
            }}
        </AuthConsumer>
    );

    return <Route {...rest} render={renderFn(component)} />;
}